/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatchlistAdoptionDto
 */
export interface WatchlistAdoptionDto {
    /**
     * Number of users with at least one watchlist
     * @type {number}
     * @memberof WatchlistAdoptionDto
     */
    usersCount: number;
    /**
     * Percentage of total users
     * @type {number}
     * @memberof WatchlistAdoptionDto
     */
    percentage: number;
    /**
     * Total number of watchlists across all users
     * @type {number}
     * @memberof WatchlistAdoptionDto
     */
    totalWatchlists: number;
}

export function WatchlistAdoptionDtoFromJSON(json: any): WatchlistAdoptionDto {
    return WatchlistAdoptionDtoFromJSONTyped(json, false);
}

export function WatchlistAdoptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchlistAdoptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usersCount': json['usersCount'],
        'percentage': json['percentage'],
        'totalWatchlists': json['totalWatchlists'],
    };
}

export function WatchlistAdoptionDtoToJSON(value?: WatchlistAdoptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usersCount': value.usersCount,
        'percentage': value.percentage,
        'totalWatchlists': value.totalWatchlists,
    };
}

